module.exports = __webpack_public_path__ + "static/cdixon-avatar-7ad99eaa3541df7cfb2d4756da936efc.png";